const data = {
    backgroundColor: "#0f0f0f",
    foregroundColor: "#5d7d93",
}


export default data;